<template>
    <div class="px-0 bg-white xl:px-2">
        <div class="flex-wrap justify-center" id="designer">
            <div class="relative w-full">
                <div class="relative">
                    <img src="@/assets/images/jpg/config2.jpg">
                    <div class="absolute render-position">
                        <!-- Rail Sliding Door  -->
                        <div 
                            class="absolute bottom-0 flex items-end justify-center w-full" 
                            :style="{ height: `${calcDoorHeight}%` }"
                        >
                            <div 
                                class="absolute bottom-0 w-full ruler-door-slide"
                                :class="setFrameBgColor"
                                :style="{ width: `${calcDoorRailSlideWidth}%` }"
                                v-if="doorType === 'slide'"
                            >
                            </div>
                        </div>

                        <div class="relative flex items-end justify-center w-full h-full m-0">
                            <!-- Door container & background -->
                            <div 
                                class="flex items-end justify-center bg-bottom bg-no-repeat bg-cover render-bg" 
                                :style="{ width: `${calcDoorWidthFull}%`, height: `${calcDoorHeight}%` }"
                            >

                                <!-- Side Panel Left -->
                                <div 
                                    class="relative flex items-end h-full" 
                                    :style="{ width: `${calcSidePanelWidth}%` }"
                                    v-if="sidePanelAmount === 'left' || sidePanelAmount === 'both'"
                                >
                                    <div 
                                        class="relative w-full h-full border-4 gap-left door"
                                        :class="[setGlassClass, setFrameColor]"
                                        id="side-panel-container"
                                    >
                                        
                                        <!-- Side panel beams left -->
                                        <VueDragResize 
                                            :isDraggable="true"
                                            :isResizable="false" 
                                            :parentLimitation="true" 
                                            :parentW="2000"
                                            :y="sidePanelBeamPosition[index].value"
                                            :h="doorDivisionSize"
                                            :style="{ width: `100%` }"
                                            axis="y"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move"
                                            v-for="(sidePanelBeamLeft, index) in sidePanelBeamAmount" 
                                            :key="'sidePanelBeamLeft' + index"
                                        >
                                        </VueDragResize>

                                        <!-- Side panel uprights left -->
                                        <VueDragResize 
                                            :isDraggable="true"
                                            :isResizable="false" 
                                            :parentLimitation="true" 
                                            :x="sidePanelUprightPosition[index].value"
                                            :w="doorDivisionSize"
                                            :style="{ height: `100%` }"
                                            axis="x"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move"
                                            v-for="(sidePanelUprightLeft, index) in sidePanelUprightAmount" 
                                            :key="'sidePanelUprightLeft' + index"
                                        >
                                        </VueDragResize>

                                        <!-- Ruler Horizontal -->
                                        <div class="absolute left-0 w-full h-px bg-black ruler-horizontal"></div>
                                        <div class="absolute px-2 py-0 text-sm font-bold leading-5 text-center text-black whitespace-no-wrap ruler-text-horizontal">
                                            {{ sidePanelWidth }}cm
                                        </div>
                                    </div>
                                    <!-- Ruler Vertical - Height - Side panel left -->
                                    <div class="absolute top-0 w-px h-full bg-black ruler-vertical"></div>
                                    <div class="absolute left-auto px-2 py-0 text-sm font-bold leading-5 text-center text-black whitespace-no-wrap ruler-text-vertical">
                                        {{ doorHeight }}cm
                                    </div>
                                </div>

                                <!-- Ruler Vertical - Height - Door -->
                                <div 
                                    class="relative h-full" 
                                    v-if="sidePanelAmount === 'right' || sidePanelAmount === 'none'"
                                >
                                    <div class="absolute top-0 w-px h-full bg-black ruler-vertical"></div>
                                    <div class="absolute left-auto px-2 py-0 text-sm font-bold leading-5 text-center text-black whitespace-no-wrap ruler-text-vertical">
                                        {{ doorHeight }}cm
                                    </div>
                                </div>

                                <!-- Door Container 1 -->
                                <div
                                    class="relative flex items-end h-full"
                                    :style="{ width: `${calcDoorWidthMultiple}%` }"
                                    :class="{'pivot-gap': doorType === 'pivot' && doorAmount > 1}"
                                >
                                    <!-- Door Border & Glass -->
                                    <div
                                        class="relative w-full h-full door"
                                        :class="[setGlassClass, setFrameColor]"
                                        id="door-container0"
                                    >
                                        <!-- Ruler Horizontal -->
                                        <div class="absolute left-0 w-full h-px bg-black ruler-horizontal"></div>
                                        <div class="absolute px-2 py-0 text-sm font-bold leading-5 text-center text-black whitespace-no-wrap ruler-text-horizontal">
                                            {{ doorWidth }}cm
                                        </div>

                                        <!-- Doorhandle if door > 2 & sidepanels = left || right -->
                                        <div 
                                            class="absolute" 
                                            :style="{ width: `100%`, height: `100%` }"
                                            v-if="doorAmount == 2 && (sidePanelAmount === 'left' || sidePanelAmount === 'right')"
                                        >
                                            <!-- Door handle right -->
                                            <div 
                                                class="absolute right-0 door-handle"
                                                :class="setFrameBgColor"
                                                :style="{ bottom: `${calcDoorHandlePosition}%`, height: `${calcDoorHandleLength}%` }"
                                                v-if="doorAmount === 2"
                                            >
                                            </div>
                                        </div>

                                        <!-- Doorhandle if doorAmount = 1 -->
                                        <div 
                                            class="absolute right-0 h-12 door-handle-single"
                                            :class="setFrameBgColor"
                                            :style="{ bottom: `${calcDoorHandlePosition}%`, height: `${calcDoorHandleLength}%` }"
                                            v-if="doorAmount === 1 && doorType != 'fixed'"
                                        >
                                        </div>

                                        <!-- Heightened top & bottom frame for pivot -->
                                        <div 
                                            class="absolute bottom-0 w-full h-1"
                                            :class="setFrameBgColor"
                                            v-if="doorType === 'pivot'"
                                        >
                                        </div>
                                        <div 
                                            class="absolute top-0 w-full h-1"
                                            :class="setFrameBgColor"
                                            v-if="doorType === 'pivot'"
                                        >
                                        </div>

                                        <!-- Bottom panel -->
                                        <div 
                                            class="absolute bottom-0 w-full"
                                            :class="setFrameBgColor"
                                            v-if="bottomPanel"
                                            :style="{ height: `20%` }"
                                        ></div> 

                                        <div>

                                        </div>

                                        <!-- Door beams -->
                                        <!-- :parentW fixes issue with draggable beam being outside of parent on click, resets after 2nd click -->
                                        <VueDragResize 
                                            :isResizable="false" 
                                            :parentLimitation="true" 
                                            :y="doorBeamPosition[index].value"
                                            :h="doorDivisionSize"
                                            :parentW="500000"
                                            :style="{ width: `100%` }"
                                            axis="y"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move"
                                            v-for="(doorBeam, index) in doorBeamAmount" 
                                            :key="'doorBeam' + index"
                                        >
                                        </VueDragResize>

                                        <!-- Door Uprights -->
                                        <VueDragResize 
                                            :isDraggable="true"
                                            :isResizable="false" 
                                            :parentLimitation="true" 
                                            :x="doorUprightPosition[index].value"
                                            :w="doorDivisionSize"
                                            :style="{ height: `100%` }"
                                            axis="x"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move"
                                            v-for="(doorUpright, index) in doorUprightAmount" 
                                            :key="'doorUpright' + index"
                                            :id="'doorUpright' + index"
                                        >
                                        </VueDragResize>

                                    </div>                      
                                </div>

                                <!-- Door Container 2 -->
                                 <!--Glaskleur toevoegen in deze div  -->
                                <div
                                    class="relative flex items-end h-full"
                                    :style="{ width: `${calcDoorWidthMultiple}%` }"
                                    :class="{'pivot-gap': doorType === 'pivot' && doorAmount > 1}"
                                    v-if="doorAmount === 2"
                                    id="door-container1"
                                    ref="doorContainer"
                                >
                                
                                    <!-- Door Border & Glass -->
                                    <div 
                                        class="relative w-full h-full door"
                                        :class="[setGlassClass, setFrameColor]"
                                    >
                                        <!-- Ruler Horizontal -->
                                        <div class="absolute left-0 w-full h-px bg-black ruler-horizontal"></div>
                                        <div class="absolute px-2 py-0 text-sm font-bold leading-5 text-center text-black whitespace-no-wrap ruler-text-horizontal">
                                            {{ doorWidth }}cm
                                        </div>


                                        <!-- Doorhandle if door > 2 & sidepanels = left || right -->
                                        <div 
                                            class="absolute" 
                                            :style="{ width: `100%`, height: `100%` }"
                                            v-if="doorAmount == 2 && (sidePanelAmount === 'left' || sidePanelAmount === 'right')"
                                        >
                                            <!-- Door handle left -->
                                            <div 
                                                class="absolute left-0 door-handle"
                                                :class="setFrameBgColor"
                                                :style="{ bottom: `${calcDoorHandlePosition}%`, height: `${calcDoorHandleLength}%` }"
                                                v-if="doorAmount === 2"
                                            >
                                            </div>
                                        </div>


                                        <!-- Heightened top & bottom frame for pivot -->
                                        <div 
                                            class="absolute bottom-0 w-full h-1"
                                            :class="setFrameBgColor"
                                            v-if="doorType === 'pivot'"
                                        >
                                        </div>
                                        <div 
                                            class="absolute top-0 w-full h-1"
                                            :class="setFrameBgColor"
                                            v-if="doorType === 'pivot'"
                                        >
                                        </div>

                                        <!-- Bottom panel -->
                                        <div 
                                            class="absolute bottom-0 w-full"
                                            :class="setFrameBgColor"
                                            v-if="bottomPanel"
                                            :style="{ height: `20%` }"
                                        ></div>                                        
                                    
                                        <!-- Door beams -->
                                        <VueDragResize 
                                            :isResizable="false" 
                                            :parentLimitation="true"
                                            :parentW="2000"
                                            :y="doorBeamPosition[index].value"
                                            :h="doorDivisionSize"
                                            :style="{ width: `100%` }"
                                            axis="y"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move"
                                            v-for="(doorBeam, index) in doorBeamAmount" 
                                            :key="'doorBeam2' + index"
                                        >
                                        </VueDragResize>

                                        <!-- Door Uprights -->
                                        <VueDragResize 
                                            :isDraggable="true"
                                            :isResizable="false" 
                                            :parentLimitation="true" 
                                            :x="doorUprightPosition[index].value"
                                            :w="doorDivisionSize"
                                            :style="{ height: `100%` }"
                                            axis="x"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move"
                                            v-for="(doorUpright, index) in doorUprightAmount" 
                                            :key="'doorUpright' + index"
                                            :id="'doorUpright2' + index"
                                        >
                                        </VueDragResize>

                                    </div>                      
                                </div>

                                <!-- Side Panel Right -->
                                <div 
                                    class="relative flex items-end h-full" 
                                    :style="{ width: `${calcSidePanelWidth}%` }"
                                    v-if="sidePanelAmount === 'right' || sidePanelAmount === 'both'"
                                >
                                    <div 
                                        class="relative w-full h-full border-4 shadow-md gap-right door" 
                                        :class="[setGlassClass, setFrameColor]"
                                        id="side-panel-container"
                                    >

                                        <!-- Side panel beams right -->
                                        <VueDragResize 
                                            :isDraggable="true"
                                            :isResizable="false" 
                                            :parentLimitation="true"
                                            :parentW="2000"
                                            :y="sidePanelBeamPosition[index].value"
                                            :h="doorDivisionSize"
                                            :style="{ width: `100%` }"
                                            axis="y"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move"
                                            v-for="(sidePanelBeamRight, index) in sidePanelBeamAmount" 
                                            :key="'sidePanelBeamRight' + index"
                                        >
                                        </VueDragResize>

                                        <!-- Side panel uprights right -->
                                        <VueDragResize 
                                            :isDraggable="true"
                                            :isResizable="false" 
                                            :parentLimitation="true" 
                                            :x="sidePanelUprightPosition[index].value"
                                            :w="doorDivisionSize"
                                            :style="{ height: `100%` }"
                                            axis="x"
                                            :z="49"
                                            :class="setFrameBgColor"
                                            class="cursor-move" 
                                            v-for="(sidePanelUprightRight, index) in sidePanelUprightAmount" 
                                            :key="'sidePanelUprightRight' + index"
                                        >
                                        </VueDragResize>

                                        <!-- Ruler Horizontal -->
                                        <div class="absolute left-0 w-full h-px bg-black ruler-horizontal"></div>
                                        <div class="absolute px-2 py-0 text-sm font-bold leading-5 text-center text-black whitespace-no-wrap ruler-text-horizontal">
                                            {{ sidePanelWidth }}cm
                                        </div>
                                    </div>
                                </div>

                            </div>
                            
                            <!-- TODO: refactor code into one component with props to reuse -->
                            <!-- Doorhandle if doorAmount = 2 & sidepanels > 1 --> 
                            <div 
                                class="absolute flex items-end justify-center" 
                                :style="{ width: `${calcDoorWidthFull}%`, height: `${calcDoorHeight}%` }"
                                v-if="doorAmount === '2' && (doorType != 'fixed' || sidePanelAmount != 'right' || sidePanelAmount !='left') || (sidePanelAmount === 'none' || sidePanelAmount === 'both')"
                            >
                                <!-- Door handle left -->
                                <div class="relative items-end justify-center w-1/2 h-full">
                                    <div 
                                        class="absolute right-0 door-handle"
                                        :class="setFrameBgColor"
                                        :style="{ bottom: `${calcDoorHandlePosition}%`, height: `${calcDoorHandleLength}%` }"
                                        v-if="doorAmount === 2 && doorType != 'fixed'"
                                    >
                                    </div>
                                </div>
                                <!-- Door handle right -->
                                <div 
                                    class="relative items-end justify-center w-1/2 h-full"
                                    :class="{'ml-1': doorType === 'pivot' && doorAmount > 1}"
                                >
                                    <div 
                                        class="absolute left-0 door-handle"
                                        :class="setFrameBgColor"
                                        :style="{ bottom: `${calcDoorHandlePosition}%`, height: `${calcDoorHandleLength}%` }"
                                        v-if="doorAmount === 2 && doorType != 'fixed'"
                                    >
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import VueDragResize from 'vue-drag-resize'
    import { mapState } from 'vuex'
    import { mapMutations } from 'vuex'
    import * as htmlToImage from 'html-to-image'
    
    export default {
        components: {
            VueDragResize,
        },
        data() {
            return {
                doorHeightRatio: 350,
                doorWidthRatio: 699,
                doorHandleCenter: 110,
                doorHandleLength: 50,
                bottomPanel: false,
                doorBeamPosition: [
                    { value: 0 },
                    { value: 0 },   
                    { value: 0 },
                    { value: 0 },
                ],
                doorUprightPosition: [
                    { value: 0 },
                    { value: 0 },   
                    { value: 0 },
                    { value: 0 },
                ],
                sidePanelBeamPosition: [
                    { value: 0 },
                    { value: 0 },   
                    { value: 0 },
                    { value: 0 },
                ],
                sidePanelUprightPosition: [
                    { value: 0 },
                    { value: 0 },   
                    { value: 0 },
                    { value: 0 },
                ],
                doorDivisionSize: 2,
            }
        },
        methods: {
            ...mapMutations([
                'setImageUrl',
                'setSnapShot'
            ]),
        },
        computed: {
            ...mapState([
                'doorHeight',
                'doorWidth',
                'doorType',
                'doorAmount',
                'sidePanelWidth',
                'sidePanelAmount',
                'doorDivision',
                'doorPixels',
                'doorBeamAmount',
                'doorUprightAmount',
                'sidePanelBeamAmount',
                'sidePanelUprightAmount',
                'glassType',
                'frameColor',
                'snapShot',
            ]),
            calcDoorWidth() {
                let doorWidthCalc = (100 * this.doorWidth / this.doorWidthRatio) * this.doorAmount

                doorWidthCalc = doorWidthCalc - 0.001

                return doorWidthCalc
            },
            calcDoorHeight() {
                let doorHeightCalc = (100 * this.doorHeight / this.doorHeightRatio)

                return doorHeightCalc
            },
            calcSidePanelWidth() {
                let sidePanelAmountNumber = ''
                
                if(this.sidePanelAmount === 'left' || this.sidePanelAmount === 'right') {
                    sidePanelAmountNumber = 1
                }  else if (this.sidePanelAmount === 'both') {
                        sidePanelAmountNumber = 2
                    } else {
                        sidePanelAmountNumber = 0
                    }

                let sidePanelWidthPercentage = (100 * this.sidePanelWidth / this.doorWidthRatio)          
                let doorWidthCalc = (((100 * this.doorWidth / this.doorWidthRatio) * this.doorAmount) + ((100 * this.sidePanelWidth / this.doorWidthRatio) * sidePanelAmountNumber))
                let sidePanelWidthMultiple = ((100 * (sidePanelWidthPercentage * sidePanelAmountNumber)) / doorWidthCalc) / sidePanelAmountNumber

                return sidePanelWidthMultiple;
            },
            calcDoorWidthFull() {
                let sidePanelAmountNumber = ''
                if(this.sidePanelAmount === 'left' || this.sidePanelAmount === 'right') {
                    sidePanelAmountNumber = 1
                }  else if (this.sidePanelAmount === 'both') {
                        sidePanelAmountNumber = 2
                    } else {
                        sidePanelAmountNumber = 0
                    }
                
                let doorWidthCalcFull = ''
                doorWidthCalcFull = (((100 * this.doorWidth / this.doorWidthRatio) * this.doorAmount) + ((100 * this.sidePanelWidth / this.doorWidthRatio) * sidePanelAmountNumber))
                doorWidthCalcFull = doorWidthCalcFull - 0.001;
                return doorWidthCalcFull;

            },
            calcDoorWidthMultiple() {  
                let sidePanelAmountNumber = ''
                if(this.sidePanelAmount === 'left' || this.sidePanelAmount === 'right') {
                    sidePanelAmountNumber = 1
                }  else if (this.sidePanelAmount === 'both') {
                        sidePanelAmountNumber = 2
                    } else {
                        sidePanelAmountNumber = 0
                    }

                let doorWidthPercentage = (100 * this.doorWidth / this.doorWidthRatio);           
                let doorWidthCalc = (((100 * this.doorWidth / this.doorWidthRatio) * this.doorAmount) + ((100 * this.sidePanelWidth / this.doorWidthRatio) * sidePanelAmountNumber))
                
                let doorWidthMultiple = ((100 * (doorWidthPercentage * this.doorAmount)) / doorWidthCalc) / this.doorAmount;
                                    
                return doorWidthMultiple;
            },
            calcDoorRailSlideWidth() {
                let doorWidthCalc = ''
                doorWidthCalc = (100 * this.doorWidth / this.doorWidthRatio) * this.doorAmount
                doorWidthCalc = doorWidthCalc * 1.5 - 0.001
                return doorWidthCalc
            },
            calcDoorHandlePosition() {
                // let doorHandleMinus = ''
                // doorHandleMinus = (100 * this.doorHandleLength / this.doorHeightRatio)

                let doorHandlePosition = ''
                doorHandlePosition = (100 * this.doorHandleCenter / this.doorHeightRatio)
                return doorHandlePosition //- doorHandleMinus
            },
            calcDoorHandleLength() {
                let doorHandleLength = ''
                doorHandleLength = (100 * this.doorHandleLength / this.doorHeightRatio)
                return doorHandleLength
            },
            setGlassClass() {
                let glassClass = ''
                glassClass = 'glass-' + this.glassType
                return glassClass
            },
            setFrameColor() {
                let frameClass = ''
                frameClass = 'frame-border-' + this.frameColor
                return frameClass 
            },
            setFrameBgColor() {
                let borderClass = ''
                borderClass = 'frame-bg-' + this.frameColor
                return borderClass 
            }
        },
        watch: {
            doorBeamAmount() {
                
                let doorSelector = document.querySelector('#door-container0')
                let doorPixels = doorSelector.clientHeight

                if(this.doorBeamAmount === 1) {
                    this.doorBeamPosition[0].value = ((doorPixels/2)-1.5)
                }
                else if(this.doorBeamAmount === 2) {
                    this.doorBeamPosition[0].value = ((doorPixels/3)-1.5)
                    this.doorBeamPosition[1].value = (((doorPixels/3)*2)-1.5)
                }
                else if(this.doorBeamAmount === 3) {
                    this.doorBeamPosition[0].value = ((doorPixels/4)-1.5)
                    this.doorBeamPosition[1].value = ((doorPixels/2)-1.5)
                    this.doorBeamPosition[2].value = (((doorPixels/4)*3)-1.5)
                }
                else {
                    this.doorBeamPosition[0].value = ((doorPixels/5)-1.5)
                    this.doorBeamPosition[1].value = (((doorPixels/5)*2)-1.5)
                    this.doorBeamPosition[2].value = (((doorPixels/5)*3)-1.5)
                    this.doorBeamPosition[3].value = (((doorPixels/5)*4)-1.5)
                }
            },

            doorUprightAmount() {

                let doorSelector = document.querySelector('#door-container0')
                let doorPixels = doorSelector.clientWidth

                if(this.doorUprightAmount === 1) {
                    this.doorUprightPosition[0].value = ((doorPixels/2)-1.5)
                }
                else if(this.doorUprightAmount === 2) {
                    this.doorUprightPosition[0].value = ((doorPixels/3)-1.5)
                    this.doorUprightPosition[1].value = (((doorPixels/3)*2)-1.5)
                }
                else if(this.doorUprightAmount === 3) {
                    this.doorUprightPosition[0].value = ((doorPixels/4)-1.5)
                    this.doorUprightPosition[1].value = ((doorPixels/2)-1.5)
                    this.doorUprightPosition[2].value = (((doorPixels/4)*3)-1.5)
                }
                else {
                    this.doorUprightPosition[0].value = ((doorPixels/5)-1.5)
                    this.doorUprightPosition[1].value = (((doorPixels/5)*2)-1.5)
                    this.doorUprightPosition[2].value = (((doorPixels/5)*3)-1.5)
                    this.doorUprightPosition[3].value = (((doorPixels/5)*4)-1.5)
                }
            },
            sidePanelBeamAmount() {

                let sidePanelSelector = document.querySelector('#side-panel-container')
                let sidePanelPixels = sidePanelSelector.clientHeight

                if(this.sidePanelBeamAmount === 1) {
                    this.sidePanelBeamPosition[0].value = ((sidePanelPixels/2)-1.5)

                }
                else if(this.sidePanelBeamAmount === 2) {
                    this.sidePanelBeamPosition[0].value = ((sidePanelPixels/3)-1.5)
                    this.sidePanelBeamPosition[1].value = (((sidePanelPixels/3)*2)-1.5)
                }
                else if(this.sidePanelBeamAmount === 3) {
                    this.sidePanelBeamPosition[0].value = ((sidePanelPixels/4)-1.5)
                    this.sidePanelBeamPosition[1].value = ((sidePanelPixels/2)-1.5)
                    this.sidePanelBeamPosition[2].value = (((sidePanelPixels/4)*3)-1.5)
                }
                else {
                    this.sidePanelBeamPosition[0].value = ((sidePanelPixels/5)-1.5)
                    this.sidePanelBeamPosition[1].value = (((sidePanelPixels/5)*2)-1.5)
                    this.sidePanelBeamPosition[2].value = (((sidePanelPixels/5)*3)-1.5)
                    this.sidePanelBeamPosition[3].value = (((sidePanelPixels/5)*4)-1.5)
                }
            },
            sidePanelUprightAmount() {

                let sidePanelSelector = document.querySelector('#side-panel-container')
                let sidePanelPixels = sidePanelSelector.clientWidth

                if(this.sidePanelUprightAmount === 1) {
                    this.sidePanelUprightPosition[0].value = ((sidePanelPixels/2)-1.5)
                }
                else if(this.sidePanelUprightAmount === 2) {
                    this.sidePanelUprightPosition[0].value = ((sidePanelPixels/3)-1.5)
                    this.sidePanelUprightPosition[1].value = (((sidePanelPixels/3)*2)-1.5)
                }
                else if(this.sidePanelUprightAmount === 3) {
                    this.sidePanelUprightPosition[0].value = ((sidePanelPixels/4)-1.5)
                    this.sidePanelUprightPosition[1].value = ((sidePanelPixels/2)-1.5)
                    this.sidePanelUprightPosition[2].value = (((sidePanelPixels/4)*3)-1.5)
                }
                else {
                    this.sidePanelUprightPosition[0].value = ((sidePanelPixels/5)-1.5)
                    this.sidePanelUprightPosition[1].value = (((sidePanelPixels/5)*2)-1.5)
                    this.sidePanelUprightPosition[2].value = (((sidePanelPixels/5)*3)-1.5)
                    this.sidePanelUprightPosition[3].value = (((sidePanelPixels/5)*4)-1.5)
                }
            },
            snapShot() {
                if(this.snapShot === true) {
                    this.setSnapShot(false)

                    let node = document.getElementById('designer')
                    htmlToImage
                        .toBlob(node, {canvasWidth: 800, canvasHeight: 487})
                        .then((blob) => {
                            this.setImageUrl(blob)
                            console.log('snapshot blob made')                                       
                        })
                        .catch((error) => {
                            console.error('oops, something went wrong!', error)
                        })                
                }
            }
        }
    }
</script>

<style scoped lang="scss">

    .render-position {
        left: 11.48%;
        right: 11.48%;
        bottom: 19.6%;
        top: 18.5%;
    }

    .render-elements {
        flex: 0 0 auto;
        background-image: url(../../assets/images/jpg/configbg2.jpg);
        /* background-size: 774px; */
    }

    .render-bg {
        flex: 0 0 auto;
        background-image: url(../../assets/images/jpg/configbg2.jpg);
    }

    .door {
        flex: 0 0 auto;
        border: 2px solid;
        animation: fade-in 300ms;
    }

    @keyframes fade-in {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    .pivot-gap {
        margin-right: 1px;
    }

    .gap-left {
        margin-left: -1px;
    }

    .gap-right {
        margin-left: 1px;
    }

    .ruler-horizontal {
        top: -29px;
        animation: fade-in 300ms;
    }

    .ruler-door-slide {
        top: -8px;
        height: 6px;
        animation: fade-in 300ms;
    }

    .ruler-vertical {
        left: -49px;
        animation: fade-in 300ms;
    }

    .ruler-text-horizontal {
        left: 50%; 
        transform: translate(-50%, 0);
        top: -49px;
        animation: fade-in 300ms;
    }

    .ruler-text-vertical {
        top: 50%;
        margin-top: -10px;
        left: -89px;
        transform: rotate(-90deg);
        animation: fade-in 300ms;
    }

    .ruler-uprights {
        bottom: -30px;
        height: 20px;
        left: 1px;
        animation: fade-in 300ms;
    }

    .upright-text {
        top: 20px;
        animation: fade-in 300ms;
    }

    .door-beam {
        background: black;
        animation: fade-in 300ms;
    }

    .door-handle {
        width: 5px;
        animation: fade-in 300ms;
    }

    .door-handle-single {
        width: 4px;
        animation: fade-in 300ms;
    }

    .glass {
        &-basic {
            background-color: rgba(255, 255, 255, 0);
        }
        &-steel-wire {
            background-image: url(../../assets/images/patterns/glass-square-2.png);
            background-position: center;
        }
        &-flutes {
            background-image: url(../../assets/images/patterns/glass-vertical.png);
            background-position: center;
        }
        &-listral-d {
            background-image: url(../../assets/images/patterns/glass-dotted.png);
            background-position: center;
        }
        &-cathedral-max {
            background-image: url(../../assets/images/patterns/glass-cath-2.png);
            background-position: center;
        }
        &-visuosun {
            background-image: url(../../assets/images/patterns/glass-vertical-2.png);
            background-position: center;
        }
        &-fume-gray {
            background-color: rgba(75, 75, 75, 0.4);
        }
        &-fume-brown {
            background-color: rgba(160, 114, 67, 0.4);
        }
        &-dark-gray {
            background-color: rgba(65, 65, 65, 0.4);
        }
        &-milk {
            background-color: rgba(255, 254, 247, 0.7);
        }
        &-black {
            background-color: rgba(0, 0, 0, 0.7);
        }
        &-white {
            background-color: rgb(255, 255, 255, 0.7);
        }
    }

    .frame {

        &-border {
            animation: fade-in 300ms;
            &-9005 {
                border-color: rgb(0, 0, 0);
            }

            &-7016 {
                border-color: rgb(56, 62, 66);
            }

            &-7022 {
                border-color: rgb(76, 74, 68);
            }

            &-7039 {
                border-color: rgb(107, 102, 94);
            }

            &-9010 {
                border-color: rgb(241, 236, 225);
            }
            
            &-9003 {
                border-color: rgb(236, 236, 231);
            }
        }

        &-bg {
            &-9005 {
                background-color: rgb(0, 0, 0);
            }

            &-7016 {
                background-color: rgb(56, 62, 66);
            }

            &-7022 {
                background-color: rgb(76, 74, 68);
            }

            &-7039 {
                background-color: rgb(107, 102, 94);
            }

            &-9010 {
                background-color: rgb(241, 236, 225);
            }
            
            &-9003 {
                background-color: rgb(236, 236, 231);
            }
        }
        
    }
    
    

    @media only screen and (max-width: 600px) {
        .door {
            flex: 0 0 auto;
            border: 2px solid
        }

        .ruler-door-slide {
            top: -4px;
            height: 3px;
        }

        .door-handle {
            width: 4px;
        }

        .door-handle-single {
            width: 2px;
        }
    }
</style>
